import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import { SbSharedRefineMenuFilterDeliveryOptions } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterDeliveryOptions';

export const SbRespRefineMenuFilterDeliveryOptionsComponent = props => (
    <SbSharedRefineMenuFilterDeliveryOptions {...props} />
);

export const SbRespRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbRespRefineMenuFilterDeliveryOptionsComponent,
    {
        viewer: graphql`
            fragment SbRespRefineMenuFilterDeliveryOptions_viewer on Viewer {
                ...SbSharedRefineMenuFilterDeliveryOptions_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbRespRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuFilterDeliveryOptions_itemSearch
            }
        `,
    }
);
